import { useState } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { globalGetService } from '../../../utils/globalApiServices'
import { checkApiStatus } from '../../../utils'
import { backendDateFormat } from '../../../constants'
import { getAverageUtilizationApi, getCashflowForecastApi, getCashflowWaterfallApi, getClaimApvTurnAroundApi, getClaimStatusAndRecoveryApi, getCurrencyApi, getComponentUtilizationTrendsApi, getInvPaymentTrendsApi, getInvReceivablesApi, getPaymentTimelinessApi, getMonthlyUtilizationApi, getPlannedCompletedSVApi, getAmendmentHistoryApi, getFundMovementWaterfallApi, getMRFundBalanceByEventTypeApi, getOpenDeliveryExceptionApi, getContractActionCentreApi, getUpcomingCriticalDatesApi, contractDataComplitnessApi, contractHealthOverviewApi } from '../apiService'

const useContractAnalyticsApiHook = (params, utilType, utilVal, trendMetric) => {
  const { leaseBasicDetails } = useSelector((state) => state.leases);
  const [loading, setLoading] = useState({ monthly_utilization: true, component_utilization_trends: false, average_utilization: false, invoice_payments: true, invoice_receivables: false, payment_timeliness: false, claim_status_recovery: false, claim_approval_turnaround: false, planned_shop_visits: false, cashflow_waterfall: false, cashflow_forecast: false, amendment_history: false, fund_movement_waterfall: false, mr_fund_balance_by_event_type: false, open_delivery_exceptions: false, contract_action_centre: false, upcoming_critical_dates: false, contract_data_complitness: false, contract_overview_health: false });
  const [data, setData] = useState({})
  const [currencies, setCurrencies] = useState([])
  const [dropDownLoader, setDropDownLoader] = useState({ display_currency: false });

  const getDefaultDateRange = () => ({
    date_from: moment().subtract(1, 'year').startOf('month').format(backendDateFormat),
    date_to: moment().format(backendDateFormat),
  })

  const getMonthlyUtilizationData = (query) => {
    setLoading(prev => ({ ...prev, monthly_utilization: true }));
    globalGetService(getMonthlyUtilizationApi(query)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, monthly_utilization: response?.data?.data }));
      }
      setLoading(prev => ({ ...prev, monthly_utilization: false }));
    })
  }
  const getAverageUtilizationData = (query) => {
    setLoading(prev => ({ ...prev, average_utilization: true }));
    globalGetService(getAverageUtilizationApi(query)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, average_utilization: response?.data?.data }));
      }
      setLoading(prev => ({ ...prev, average_utilization: false }));
    })
  }
  const getComponentUtilizationTrendsData = (query) => {
    setLoading(prev => ({ ...prev, component_utilization_trends: true }));
    globalGetService(getComponentUtilizationTrendsApi(query)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, component_utilization_trends: response?.data?.data }));
      }
      setLoading(prev => ({ ...prev, component_utilization_trends: false }));
    })
  }
  const getInvPaymentTrendsData = (query) => {
    setLoading(prev => ({ ...prev, invoice_payments: true }));
    globalGetService(getInvPaymentTrendsApi(query)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, invoice_payments: response?.data?.data }));
      }
      setLoading(prev => ({ ...prev, invoice_payments: false }));
    })
  }
  const getInvReceivablesData = (query) => {
    const { lease_slug, ...rest } = query || {};
    setLoading(prev => ({ ...prev, invoice_receivables: true }));
    globalGetService(getInvReceivablesApi({ leaseSlug: lease_slug }, rest)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, invoice_receivables: response?.data?.data }));
      }
      setLoading(prev => ({ ...prev, invoice_receivables: false }));
    })
  }
  const getPaymentTimelinessData = (query) => {
    const { lease_slug, ...rest } = query || {};
    setLoading(prev => ({ ...prev, payment_timeliness: true }));
    globalGetService(getPaymentTimelinessApi({ leaseSlug: lease_slug }, rest)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, payment_timeliness: response?.data?.data }));
      }
      setLoading(prev => ({ ...prev, payment_timeliness: false }));
    })
  }
  const getClaimsRecoveryData = (query) => {
    setLoading(prev => ({ ...prev, claim_status_recovery: true }));
    globalGetService(getClaimStatusAndRecoveryApi(query)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, claim_status_recovery: response?.data?.data }));
      }
      setLoading(prev => ({ ...prev, claim_status_recovery: false }));
    })
  }
  const getClaimApvTurnAroundData = (query) => {
    setLoading(prev => ({ ...prev, claim_approval_turnaround: true }));
    globalGetService(getClaimApvTurnAroundApi(query)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, claim_approval_turnaround: response?.data?.data }));
      }
      setLoading(prev => ({ ...prev, claim_approval_turnaround: false }));
    })
  }
  const getPlannedCompletedSVData = (query) => {
    setLoading(prev => ({ ...prev, planned_shop_visits: true }));
    globalGetService(getPlannedCompletedSVApi(query)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, planned_shop_visits: response?.data?.data }));
      }
      setLoading(prev => ({ ...prev, planned_shop_visits: false }));
    })
  }
  const getCashflowWaterfallApiData = (query) => {
    setLoading(prev => ({ ...prev, cashflow_waterfall: true }));
    globalGetService(getCashflowWaterfallApi(query)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, cashflow_waterfall: response?.data?.data }));
      }
      setLoading(prev => ({ ...prev, cashflow_waterfall: false }));
    })
  }
  const getCashflowForecastData = (query) => {
    setLoading(prev => ({ ...prev, cashflow_forecast: true }));
    globalGetService(getCashflowForecastApi(query)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, cashflow_forecast: response?.data?.data }));
      }
      setLoading(prev => ({ ...prev, cashflow_forecast: false }));
    })
  }

  const getAmendmentHistoryData = (query) => {
    const { lease_slug, ...rest } = query || {};
    setLoading(prev => ({ ...prev, amendment_history: true }));
    globalGetService(getAmendmentHistoryApi({ leaseSlug: lease_slug }, rest)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, amendment_history: response?.data?.data }));
      }
      setLoading(prev => ({ ...prev, amendment_history: false }));
    })
  }

  const getFundMovementWaterfallData = (query) => {
    const { lease_slug, ...rest } = query || {};
    setLoading(prev => ({ ...prev, fund_movement_waterfall: true }));
    globalGetService(getFundMovementWaterfallApi({ leaseSlug: lease_slug }, rest)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, fund_movement_waterfall: response?.data?.data }));
      }
      setLoading(prev => ({ ...prev, fund_movement_waterfall: false }));
    })
  }

  const getOpenRedeliveryExceptionsData = (query) => {
    const {lease_slug, ...rest} = query || {};
    setLoading(prev => ({ ...prev, open_delivery_exceptions: true}));
    globalGetService(getOpenDeliveryExceptionApi({ leaseSlug: lease_slug}, rest)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, open_delivery_exceptions: response?.data?.data }));
      }
      setLoading(prev => ({ ...prev, open_delivery_exceptions: false}));
    })
  }

  const getContractActionCentreData = (query) => {
    const {lease_slug, ...rest} = query || {};
    setLoading(prev => ({ ...prev, contract_action_centre: true }));
    globalGetService(getContractActionCentreApi({ leaseSlug: lease_slug}, rest)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, contract_action_centre: response?.data?.data }));
      } 
      setLoading(prev => ({ ...prev, contract_action_centre: false }));
    })
  }
  
  const getUpcomingCriticalDatesData = (query) => {
    const {lease_slug, ...rest} = query || {};
    setLoading(prev => ({ ...prev, upcoming_critical_dates: true }));
    globalGetService(getUpcomingCriticalDatesApi({ leaseSlug: lease_slug}, rest)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, upcoming_critical_dates: response?.data?.data}));
      }
      setLoading(prev => ({ ...prev, upcoming_critical_dates: false }));
    })
  }

  const getContractDataComplitnessData = (query) => {
    const {lease_slug, ...rest} = query || {};
    setLoading(prev => ({ ...prev, contract_data_complitness: true }));
    globalGetService(contractDataComplitnessApi({ leaseSlug: lease_slug}, rest)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, contract_data_complitness: response.data.data}));
      }
      setLoading(prev => ({ ...prev, contract_data_complitness: false }));
    })
  }

  const getContractHealthOverviewData = (query) => {
    const {lease_slug, ...rest} = query || {};
    setLoading(prev => ({ ...prev, contract_overview_health: true }));
    globalGetService(contractHealthOverviewApi({ leaseSlug: lease_slug}, rest)).then(response => {
      if (checkApiStatus(response)) {
        setData( prev => ({ ...prev, contract_overview_health: response.data.data }));
      }
      setLoading(prev => ({ ...prev, contract_overview_health: false }));
    })
  }

  const getMRFundBalanceByEventTypeData = (query) => {
    const { lease_slug, ...rest } = query || {};
    setLoading(prev => ({ ...prev, mr_fund_balance_by_event_type: true }));
    globalGetService(getMRFundBalanceByEventTypeApi({ leaseSlug: lease_slug }, rest)).then(response => {
      if (checkApiStatus(response)) {
        setData(prev => ({ ...prev, mr_fund_balance_by_event_type: response?.data?.data }));
      }
      setLoading(prev => ({ ...prev, mr_fund_balance_by_event_type: false }));
    })
  }

  const fetchAllContractAnalytics = (query) => {
    setData({});
    getClaimsRecoveryData(query);
    // getClaimApvTurnAroundData(query);
    // getPlannedCompletedSVData(query);
    // getCashflowWaterfallApiData(query);
    // getCashflowForecastData(query);
    getInvReceivablesData(query)
    getPaymentTimelinessData(query)
    getAverageUtilizationData({ ...query, period: utilVal });
    getComponentUtilizationTrendsData({ ...query, type: trendMetric })
    getAmendmentHistoryData(query);
    getMRFundBalanceByEventTypeData({ lease_slug: query?.lease_slug, as_of_date: query?.date_to ? query?.date_to : getDefaultDateRange()?.date_to, display_currency_id: query?.display_currency_id || '1' })
    // getOpenRedeliveryExceptionsData(query);
    // getContractActionCentreData(query);
    getUpcomingCriticalDatesData(query);
    getContractDataComplitnessData(query);
    // getContractHealthOverviewData(query);
  }
  const getCurrencyData = () => {
    setDropDownLoader(prev => ({ ...prev, display_currency: true }))
    globalGetService(getCurrencyApi()).then(response => {
      setDropDownLoader(prev => ({ ...prev, display_currency: false }))
      if (checkApiStatus(response)) {
        setCurrencies(response?.data?.data || []);
      }
    })
  }

  return {
    leaseBasicDetails,
    loading,
    setLoading,
    data,
    setData,
    currencies,
    dropDownLoader,
    getDefaultDateRange,
    getMonthlyUtilizationData,
    getClaimsRecoveryData,
    getClaimApvTurnAroundData,
    getPlannedCompletedSVData,
    getCashflowWaterfallApiData,
    getCashflowForecastData,
    getAverageUtilizationData,
    getComponentUtilizationTrendsData,
    getInvPaymentTrendsData,
    getInvReceivablesData,
    getPaymentTimelinessData,
    fetchAllContractAnalytics,
    getCurrencyData,
    getAmendmentHistoryData,
    getFundMovementWaterfallData,
    getMRFundBalanceByEventTypeData,
    // getOpenRedeliveryExceptionsData,
    // getContractActionCentreData,
    getUpcomingCriticalDatesData,
    getContractDataComplitnessData,
    // getContractHealthOverviewData,
  }
}

export default useContractAnalyticsApiHook
